import {Component} from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable()
export class NotificationService {
    constructor(public toastCtrl: ToastController) {
    }

    async create(text: string) {
        const toast = await this.toastCtrl.create({
            message: text,
            position: 'top',
            duration: 2000
        });
        toast.present();
    }
}
